import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";
import * as globalConst from './../../../../constants';

import { Subject } from "rxjs/Rx";

@Injectable()
export class BcAccountClientService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	constructor(private http: Http) { }

	public selectedBillings: any[] = [];
	public currentClientHaveTitles: boolean = false;

	//Subject created to control any change in titles
	public billingChaged = new Subject<boolean>();

	//Subject created to control any change in proposals
	public proposalChanged = new Subject<boolean>();

	public hasStatus = false;

	setBilling(checked, obj) {
		if (checked) {
			this.selectedBillings.push(obj);
		} else {
			for (var i = 0; i < this.selectedBillings.length; i++) {
				if (this.selectedBillings[i].NumeroDocumento === obj.NumeroDocumento &&
					this.selectedBillings[i].Linha === obj.Linha &&
					this.selectedBillings[i].AnoExercicio === obj.AnoExercicio) {
					delete this.selectedBillings[i];
					this.selectedBillings = this.selectedBillings.filter(item => item); // delete keep de item as undefined, so remove this
				}
			}
		}

		this.hasStatus = this.selectedBillings.some(sb => sb.PropostaStatus != null && sb.PropostaStatus != '' && sb.PropostaStatus != ' ');

		console.log("Titulo Selecionados", this.selectedBillings);
	}

	getIntegrantes(clientID) {
		return this.http
			.get(this.apiUrl + "accounts/v1/titlecustomergroup/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getTitulosNoPaginate(clientID) {
		return this.http
			.get(this.apiUrl + "collect/v1/customertit/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getTitulos(clientID, orderby, sort, page, qtdPaginas) {
		return this.http
			.get(this.apiUrl + "collect/v1/customertit/" + clientID + "?$orderby=" + orderby + " " + sort + "&$top=" + qtdPaginas + "&$skip=" + page, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	exportExcel(clientID) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "collect/v1/customertitexcel/" + clientID, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}


	// ================================== Visitation Section =======================================

	getVisitation(clientID) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getlistVisit/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	requestVisitation(clientID) {

		const objToSend = {
			ContaClienteID: clientID
		}

		return this.http
			.post(this.apiUrl + "accounts/v1/postInsertVisit/", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	returnVisitation(visitationID, clientID, parecer, dataParecer) {

		const objToSend = {
			id: visitationID,
			ContaClienteID: clientID,
			Parecer: parecer,
			DataParecer: dataParecer
		}

		return this.http
			.post(this.apiUrl + "accounts/v1/postUpdateVisit/", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ================================== End of Visitation Section =======================================

	// ================================== Property Search Section =======================================

	getPropertySearch(clientID) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getListPatrimony/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	requestPropertySearch(clientID) {

		const objToSend = {
			ContaClienteID: clientID
		}

		return this.http
			.post(this.apiUrl + "accounts/v1/postInsertPatrimony", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	returnPropertySearch(propertySearchID, clientID, patrimonio, dataPatrimonio) {

		const objToSend = {
			id: propertySearchID,
			ContaClienteID: clientID,
			Patrimonio: patrimonio,
			DataPatrimonio: dataPatrimonio
		}


		return this.http
			.post(this.apiUrl + "accounts/v1/postUpdatePatrimony/", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ================================== End of Property Search Section =======================================

	getComments(guid, orderby, sort, page) {
		page = page * globalConst.paginationSkip;

		return this.http
			.get(this.apiUrl + "commentstitle/v1/getcomments/" + guid + "?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getReasonList() {
		return this.http
			.get(this.apiUrl + "motivoabono/v1/motivosabonos?$orderby=Nome&$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getCtcByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getctcbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCollectStatus() {
		return this.http
			.get(this.apiUrl + "collectstatus/v1/list?$orderby=Descricao&$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveTitleStatus(obj) {
		return this.http
			.put(this.apiUrl + "title/v1/updatestatustitle", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ==================================== Juridical =========================================

	sendToJuridical(client) {

		var obj = {
			ContaClienteID: client.ID
		}

		return this.http
			.post(this.apiUrl + "juridical/v1/insertproposal", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getBilllingInfos(clientID) {
		return this.http
			.get(this.apiUrl + "collect/v1/exists/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getJuridicProposal(proposalID) {
		return this.http
			.get(this.apiUrl + "juridical/v1/getproposal/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveJuridicProposal(obj) {
		return this.http
			.post(this.apiUrl + "juridical/v1/saveproposal", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendJuridico(obj) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.post(this.apiUrl + "juridical/v1/sendJuridico/", obj, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	cancelJuridico(id) {
		return this.http
			.delete(this.apiUrl + "juridical/v1/inactiveproposal/"+id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ================================== End Juridical =======================================

	// ================================= Allowance ============================================

	allowAuto(objToSend) {
		return this.http
			.post(this.apiUrl + "/allowance/v1/insertauto", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	insertAllowanceProposal(objToSend) {
		return this.http
			.post(this.apiUrl + "/allowance/v1/insert", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAllowanceProposal(proposalID) {
		return this.http
			.get(this.apiUrl + "allowance/v1/get/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveAllowanceProposal(obj) {
		return this.http
			.post(this.apiUrl + "allowance/v1/save", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendAllowanceToCommittee(obj) {
		return this.http
			.post(this.apiUrl + "allowance/v1/sendcommittee", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendAllowanceToBilling(obj) {
		return this.http
			.post(this.apiUrl + "allowance/v1/sendcollection", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAllowanceCommittee(proposalID) {
		return this.http
			.get(this.apiUrl + "allowance/v1/committee/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	saveAllowanceApproval(obj) {
		return this.http
			.post(this.apiUrl + "allowance/v1/aprovedisapprove", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	cancelAllowanceProposal(id) {
		return this.http
			.post(this.apiUrl + "allowance/v1/cancel/" + id, null, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//================================== End of Allowance ======================================

	billingDocumentsSimpleAction(list) {
		return this.http
			.put(this.apiUrl + "title/v1/updatetitle", list, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ============================= Attachment section to Allowance, Juridical and Extension  =============================

	insertProposalAttachment(clientID, proposalID, proposalType, description, attachment) {


		var formData = new FormData();

		formData.append('Arquivo', attachment);
		formData.append('Proposta', proposalID);
		formData.append('ContaClienteID', clientID);
		formData.append('TipoProposta', proposalType);
		formData.append('Descricao', description);

		return this.http
			.post(this.apiUrl + "attachment/v1/chargesuploadattachment", formData, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAttachmentsList(proposalID, proposalType) {
		return this.http
			.get(this.apiUrl + "/attachment/v1/getlistattachment/" + proposalID + "/" + proposalType, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	downloadAttachment(id) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "attachment/v1/chargesdownloadattachment/" + id, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	inactivateAttachment(id) {
		return this.http
			.delete(this.apiUrl + "attachment/v1/inactiveproposalattachment/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}
	// ============================= End of Attachment  =============================

	//============================== Blog section to Allowance, Juridical and Extension  =============================

	getProposalBlog(proposalID) {
		return this.http
			.get(this.apiUrl + "blog/v1/allbyarea/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertBlogComment(obj) {
		return this.http
			.post(this.apiUrl + "blog/v1/insert/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getBlogUserList(){
		return this.http
			.get(this.apiUrl + "/users/v1/getbloguserlist/", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	//============================== End of Blog section =============================

	getFinancialSummary(id) {
		return this.http
			.get(this.apiUrl + "financialaccounts/v1/colsummary/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getLcProposal(id) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLC/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ============================= Extension Proposal  =============================

	getExtensionProposal(id) {
		return this.http
			.get(this.apiUrl + "prolongation/v1/get/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getExtensionDetails(proposalID) {
		return this.http
			.get(this.apiUrl + "prolongation/v1/details/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendExtensionProposal(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/insert/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	saveExtensionProposal(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/save/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	searchReasonOfExtension() {
		return this.http
			.get(this.apiUrl + "motivoprorrogacao/v1/motivosprorrogacoes/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendToBilling(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/sendcollection", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	searchMoneySource() {
		return this.http
			.get(this.apiUrl + "moneysource/v1/list/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	searchGuaranteeType() {
		return this.http
			.get(this.apiUrl + "typeofguarantee/v1/gettypeofguarantees/?$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	getExtensionCommittee(proposalID) {
		return this.http
			.get(this.apiUrl + "prolongation/v1/committee/" + proposalID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	addTitles(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/savepayments", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveExtensionApproval(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/aprovedisapprove", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	cancelExtensionProposal(id) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/cancel/" + id, null, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	sendExtensionToCommittee(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/sendcommittee/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	approvalExtensionProposal(obj) {
		return this.http
			.post(this.apiUrl + "prolongation/v1/aproveproposal/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ============================= End of Extension Proposal  =============================

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/service/bc-account-client.service.ts